import { createTypes, async } from 'redux-action-creator';

import asyncAction from '../../../asyncActionCreator';

import { getWaiverWorkItems } from '../../../../service/waiverWorkItemService';
import type { PromiseResultActions, Dispatch } from '../../../types';
import type {
  WaiverWorkItem,
  WaiverWorkItemSearchCriteria,
} from '../../../../types/waiverWorkItem';

export const types: { [key: string]: string } = createTypes(
  [...async('LOAD'), ...async('SYNC')],
  'WAIVER_WORK_ITEMS',
);

export const fetchWaiverWorkItems = (
  searchCriteria: WaiverWorkItemSearchCriteria,
  reload: boolean = false,
  promiseActions?: PromiseResultActions<WaiverWorkItem[], string>,
): (dispatch: Dispatch) => Promise<WaiverWorkItem[]> => {
  const actionType = reload ? 'LOAD' : 'SYNC';
  return asyncAction(
    types[actionType],
    () => getWaiverWorkItems(searchCriteria),
    promiseActions,
  );
};
